<template>
  <form-row>
    <input id="expiry-reminder" :checked="value" type="checkbox" name="order-options" @change="$emit('input', !value)">

    <label for="expiry-reminder" style="cursor: default;">
      {{ $t('product-detail.form.expiry-reminder.label') }}
      <tooltip :title="$t('product-detail.form.expiry-reminder.tooltip')" :position="'left'"/>
    </label>
  </form-row>
</template>

<script>
import FormRow from '../components/FormRow'
import Tooltip from '../../components/Tooltip'

export default {
  components: {
    FormRow,
    Tooltip
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/order-item/ExpiryReminder.vue